// Fix product tabs clickability
document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    var tabControls = document.querySelectorAll(".product-tabs .js-tab-control, .product-tabs .nav-item");
    tabControls.forEach(function(control) {
      control.style.pointerEvents = "auto";
      control.style.cursor = "pointer";
      control.style.zIndex = "1000";
      control.style.position = "relative";
      
      // Ensure click works
      control.addEventListener("click", function(e) {
        var container = control.closest(".product-tabs");
        var target = container.querySelector(control.dataset.target);
        
        // Remove active from all
        container.querySelectorAll(".js-tab-control, .nav-item").forEach(function(c) {
          c.classList.remove("active");
        });
        container.querySelectorAll(".tab-item").forEach(function(t) {
          t.classList.remove("active");
        });
        
        // Add active to clicked
        control.classList.add("active");
        if(target) target.classList.add("active");
      });
    });
  }, 1000);
});

// Also try on load
window.addEventListener("load", function() {
  var tabControls = document.querySelectorAll(".product-tabs .js-tab-control, .product-tabs .nav-item");
  tabControls.forEach(function(control) {
    control.style.pointerEvents = "auto";
    control.style.cursor = "pointer";
  });
});